// extracted by mini-css-extract-plugin
export default {"menu":"SettingsMenu_menu__F74WJ"};